<template>
  <div class="pdf-report-medicine-stock-resident">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="xl"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="container row">
          <div class="col-xl-6 col-sm-6 col-md-6 col-sm-12 col-12 text-center">
            <label>QUAL MEDICAMENTO</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="special_control"
                  @change="handleChangeInputSpecialControl"
                  id="special_control"
                />
                <label class="form-check-label" for="special_control">
                  CONTROLE ESPECIAL
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="common_use"
                  @change="handleChangeInputSpecialCommonUse"
                  id="common_use"
                />
                <label class="form-check-label" for="common_use">
                  USO COMUM
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-sm-6 col-md-6 col-sm-6 col-12 text-center">
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="handleChangeSelectResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="handleChangeSelectResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-sm-4 col-md-4 col-sm-12 col-12">
            <label>TIPO DE RELATÓRIO</label>
            <select
              :disabled="loading"
              v-model="report_type"
              @input="handleChangeSelectReportType($event.target.value)"
              class="form-control"
            >
              <option value="analytical">ANALÍTICO</option>
              <!-- <option value="general">GERAL</option> -->
            </select>
          </div>
          <div
            class="col-xl-4 col-sm-4 col-md-4 col-sm-12 col-12"
            v-if="report_type == 'general'"
          >
            <label>INTERVALO DE DIAS</label>
            <select
              :disabled="loading"
              v-model="day_interval"
              class="form-control"
            >
              <option value="7">7</option>
              <option value="10">10</option>
              <option value="15">15</option>
            </select>
          </div>
          <div class="col-xl-4 col-sm-4 col-md-4 col-sm-12 col-12">
            <label>MÊS E ANO</label>
            <input
              :disabled="loading"
              type="month"
              v-model="month"
              class="form-control"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>SELECIONE O RESIDENTE</label>
            <select
              :disabled="loading"
              v-model="resident_id"
              class="form-control"
            >
              <option
                v-for="(resident, key) in residents"
                :key="key"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: MEDICAMENTOS - PORTARIA 344/1998 - FILTRO POR RESIDENTE
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="dates.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="dates.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span><strong>RESIDENTE</strong> | </span>
            <span
              ><strong>MÊS: {{ formatDate(month, false) }}</strong> |
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="dates.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <table v-for="(resident, key) in dates" :key="key">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7">
                      <h5 class="m-0" v-if="special_control && common_use">
                        CONTROLE DE MEDICAMENTOS - CONTROLE ESPECIAL E USO COMUM
                      </h5>
                      <h5 class="m-0" v-if="special_control && !common_use">
                        CONTROLE DE MEDICAMENTOS - CONTROLE ESPECIAL
                      </h5>
                      <h5 class="m-0" v-if="!special_control && common_use">
                        CONTROLE DE MEDICAMENTOS - USO COMUM
                      </h5>
                      <div v-if="resident.id" class="d-flex align-items-center">
                        <img
                          v-if="resident.photo_url"
                          class="resident_photo_url"
                          :src="resident.photo_url"
                        />
                        <img
                          v-if="!resident.photo_url"
                          class="resident_photo_url"
                          :src="require('../../assets/user.png')"
                        />
                        <div class="ml-5">
                          <h6 class="mb-0">
                            {{ resident.name }}
                          </h6>
                          <h6 class="mb-0 worksansr upper-text">
                            Data de nascimento:
                            {{ formatDate(resident.date_of_birth, false) }}
                            -
                            {{ getAge(resident.date_of_birth) }}
                            anos
                          </h6>
                          <h6 class="mb-0 worksansr upper-text">
                            Data de admissão:
                            {{ formatDate(resident.date_of_reception, false) }}
                          </h6>
                          <h6
                            class="mb-0 worksansr upper-text"
                            v-if="resident.bed_id"
                          >
                            Leito Nº: {{ resident.bed_number }}, Andar:
                            {{ resident.bed_walk }}, ALA/Setor:
                            {{ resident.bed_ward_or_sector }}, Quarto:
                            {{ resident.bed_bedroom }}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                  <div
                    class="row"
                    v-if="resident.medicines && resident.medicines.length > 0"
                  >
                    <div class="pt-0 pb-0 col-md-7"></div>
                    <div class="text-center pt-0 pb-0 col-md-1">
                      <span>Entrada</span>
                    </div>
                    <div class="text-center pt-0 pb-0 col-md-1">
                      <span>Saída</span>
                    </div>
                    <div class="text-center pt-0 pb-0 col-md-1">
                      <span>Perda</span>
                    </div>
                    <div class="text-center pt-0 pb-0 col-md-2">
                      <span>Estoque total</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <div>
                    <div
                      v-for="(medicine, key) in resident.medicines"
                      :key="key"
                    >
                      <h5 class="m-0">
                        {{ medicine.medicine_name }}
                      </h5>
                      <h6 class="m-0">
                        {{ medicine.active_ingredient }}
                      </h6>
                      <div
                        v-if="medicine.dates && medicine.dates.length == 0"
                        class="text-center"
                      >
                        Sem movimentações!
                      </div>
                      <div
                        v-show="medicine.dates && medicine.dates.length > 0"
                        v-for="(date, key) in medicine.dates"
                        :key="key"
                      >
                        <Resident
                          :date="date"
                          :report_type="report_type"
                          :show_movimentation="show_movimentation"
                          :show_movimentation_lot="show_movimentation_lot"
                          :show_movimentation_shelf_life="
                            show_movimentation_shelf_life
                          "
                          :show_movimentation_owner="show_movimentation_owner"
                          :medicine_name="medicine.medicine_name"
                          :active_ingredient="medicine.active_ingredient"
                          :unit_of_measurement_abbreviation="
                            medicine.unit_of_measurement_abbreviation
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="dates.length > 0" class="footer text-center">
                  <hr class="mb-1 border-black" />
                  <h6 class="mb-0 worksansr">
                    (Assinatura eletrônica)
                    <strong>
                      {{
                        professionalClassCouncilValue({
                          id: user.professional_class_council_id,
                          name: user.name,
                          profile: user.profile_name,
                          cpf: user.cpf,
                          office: user.office,
                          value: user.professional_class_council_value,
                        })
                      }}
                      <span class="ml-1">
                        - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                      </span>
                    </strong>
                  </h6>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import Resident from "./MedicineStock/Resident";

import {
  formatDate,
  formatDateToMonthYear,
  professionalClassCouncilValue,
} from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { userData } from "../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsMedicineStock",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
    Resident,
  },
  data() {
    return {
      resident_active: true,
      resident_not_active: false,
      special_control: false,
      common_use: false,
      report_type: "analytical",
      filter_type: "resident",
      filter_all: "only_a_few",
      show_movimentation: true,
      show_movimentation_lot: false,
      show_movimentation_shelf_life: false,
      show_movimentation_owner: false,
      only_rest_home: false,
      month: "",
      day_interval: "7",
      resident_id: "",
      medicine_ids: [],
      residents: [],
      medicines: [],
      dates: [],
      filter_medicine_name: "",
      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loadingFilterMedicines: false,
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    formatDateToMonthYear,
    professionalClassCouncilValue,
    handleChangeSelectResidents() {
      this.getResidents();
    },
    handleChangeInputSpecialControl() {},
    handleChangeInputSpecialCommonUse() {},
    handleChangeSelectReportType(value) {
      this.show_movimentation = false;
      if (value == "analytical") {
        this.show_movimentation = true;
      }
    },
    handleChangeSelectFilterType() {
      this.only_rest_home = false;
    },
    handleChangeSelectFilterAll() {
      this.medicine_ids = [];
    },
    async retrieve() {
      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      if (this.errors.length == 0) await this.getResidents();

      if (this.errors.length == 0 && this.resident_id) {
        await this.paginate();
      }

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const {
          resident_id,
          medicine_ids,
          special_control,
          common_use,
          report_type,
          filter_type,
          filter_all,
          show_movimentation,
          show_movimentation_lot,
          show_movimentation_shelf_life,
          show_movimentation_owner,
          day_interval,
          only_rest_home,
          month,
        } = this;

        var params = {
          resident_id,
          medicine_ids,
          special_control,
          common_use,
          report_type,
          filter_type,
          filter_all,
          show_movimentation,
          show_movimentation_lot,
          show_movimentation_shelf_life,
          show_movimentation_owner,
          day_interval,
          only_rest_home,
          month,
        };

        const response = await api.get(
          "/rest-home/report/medicine-stock/filter-resident",
          {
            params,
          }
        );

        const { residents, error, errors } = response.data;

        if (error) {
          this.dates = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.dates = residents;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToPrint: () => window.print(),
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.pdf-report-medicine-stock-resident .text-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock-resident .date-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock-resident .header,
.pdf-report-medicine-stock-resident .header-space {
  height: 150px;
}

.pdf-report-medicine-stock-resident .footer,
.pdf-report-medicine-stock-resident .footer-space {
  height: 50px;
}

.pdf-report-medicine-stock-resident .header {
  position: fixed;
  top: 0;
}

.pdf-report-medicine-stock-resident .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-report-medicine-stock-resident .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-medicine-stock-resident .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-medicine-stock-resident table,
.pdf-report-medicine-stock-resident td,
.pdf-report-medicine-stock-resident th {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-medicine-stock-resident .signature {
  width: 100%;
  margin-top: 12px;
  border-top: solid 1px #000;
}

.pdf-report-medicine-stock-resident th {
  background-color: #f5f5f5;
}

.pdf-report-medicine-stock-resident .medicine-name {
  font-size: 14px;
}

.pdf-report-medicine-stock-resident small {
  font-size: 12px;
}

@media print {
  .pdf-report-medicine-stock-resident table {
    width: 100% !important;
    border: none !important;
  }

  .pdf-report-medicine-stock-resident .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .pdf-report-medicine-stock-resident .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-medicine-stock-resident .content-movimentation {
    page-break-inside: avoid !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  .pdf-report-medicine-stock-resident table {
    page-break-before: always !important;
  }

  .pdf-report-medicine-stock-resident .header,
  .pdf-report-medicine-stock-resident .header-space {
    height: 150px;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-medicine-stock-resident button {
    display: none;
  }

  .pdf-report-medicine-stock-resident .nav--bar {
    display: none !important;
  }

  .pdf-report-medicine-stock-resident .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-medicine-stock-resident .content-filter {
    display: none;
  }
}
</style>
